import gql from 'graphql-tag';
import { MICROSTORE_LOCATION_FRAGMENT } from 'data/fragments/microstoreLocation';

export const MICROSTORE_COLUMN_FRAGMENT = gql`
    fragment MicrostoreColumnFragment on MicrostoreColumn {
        _id
        createdAt
        updatedAt
        columnGroupId
        columnIdToReplace
        isPaused
        microstoreColumnTemplateId
        microstoreColumnTemplateName
        name
        state
        positionInColumnGroup
        columnGroupName
        removalDate
        externalColumnId
        externalColumnType
        avaSalePlaceId
        startingDate
        type
        microstoreColumnType
        siteId
        siteName
        isRegular
    }
`;

export const MICROSTORE_COLUMN_WITH_SHELVES_FRAGMENT = gql`
    fragment MicrostoreColumnWithShelvesFragment on MicrostoreColumn {
        _id
        microstoreColumnType
        createdAt
        updatedAt
        siteId
        siteName
        isSiteSecured
        canBeSecured
        columnGroupId
        columnIdToReplace
        isPaused
        shouldUpdateStockOnTransaction
        shouldSendNayaxPrices
        shouldIgnoreReassortThresholds
        microstoreColumnTemplateId
        name
        state
        stateHistory {
            createdAt
            createdBy
            createdByName
            state
        }
        positionInColumnGroup
        columnGroupName
        externalColumnId
        externalColumnType
        externalColumnConfig {
            nayaxMDBIntervals {
                min
                max
            }
        }
        avaSalePlaceId
        columnGroup {
            _id
            name
            columns {
                _id
                name
                positionInColumnGroup
            }
            site {
                _id
                name
                microstoreColumnGroups {
                    _id
                    name
                    positionInSite
                }
                totem {
                    _id
                    name
                    number
                    sites {
                        _id
                        name
                    }
                    organization {
                        _id
                        name
                    }
                }
            }
        }
        site {
            organizationName
            isSecured
            nextDeliveryDate
            earliestDLCDateToKeepForStockCalculation
        }
        shelves {
            _id
            locationTable {
                ...MicrostoreLocationFragment
            }
            positionInColumn
        }
        startingDate
        removalDate
        microstoreColumnTemplateName
        type
        useDynamicDelivery
        machineCode
    }
    ${MICROSTORE_LOCATION_FRAGMENT}
`;
